import React, { useEffect } from 'react'
import { SplashSignal } from '@components/SplashSignal'
import { captureReferralCode, ReferralCaptureError } from '@query/referral'
import { appendParams } from '@root/constants'
import { THEME_NAME } from '@root/styles'
import { buildReferralSignupLink } from '@utils/referralLink'
import { parseReferralCode } from '@utils/parseReferral'

const redirectToLogin = () => {
  const redirectURI = appendParams(`${import.meta.env.VITE_AUTH_BASE_URL}/auth/login/`, {
    next: window.location.href,
    theme: THEME_NAME
  })
  window.location.assign(redirectURI)
}

export const LoginRedirect: React.FC = () => {
  useEffect(() => {
    const referralCode = parseReferralCode(window.location.href)

    const redirectToAuth = async () => {
      if (!referralCode) {
        redirectToLogin()
        return
      }

      try {
        await captureReferralCode(undefined, { code: referralCode })
      } catch (error) {
        if (error instanceof ReferralCaptureError && error.code === 'invalid_code') {
          redirectToLogin()
          return
        }
      }

      window.location.assign(buildReferralSignupLink(referralCode))
    }

    void redirectToAuth()
  }, [])

  return <SplashSignal source="login-redirect" />
}
